/**
 * Converts a media URL (images, PDFs, documents) to an absolute URL
 * Handles blob:, http(s), or server-relative paths
 */
export function absolutizeMediaUrl(url?: string | null): string | undefined {
  if (!url) return undefined;

  try {
    new URL(url);
    return url;
  } catch {
    const apiBase =
      import.meta.env.VITE_API_URL ||
      'http://127.0.0.1:8000';

    const cleanBase = apiBase.replace(/\/$/, '');
    const cleanPath = url.startsWith('/') ? url : `/${url}`;

    return `${cleanBase}${cleanPath}`;
  }
}
